import groq from 'groq';

/* WARN: If you change this query, make sure to update MAX_POSSIBLE_SCORES */
export const searchSkincareIngredients = () => groq`
  *[
    _type == "timeline_skincareIngredients" &&
    !(_id in path("drafts.**"))
  ] | score(
      references(*[_type == "timeline_activeIngredient" && title match $searchTerm]._id),
    ) {
      _type,
      _score
    }[ _score > 0 ]
`;
